import { __extends } from "tslib";
import { ASObject } from '@awayfl/avm2';
import { notImplemented, release, somewhatImplemented } from '@awayfl/swf-loader';
import { axCoerceString } from '@awayjs/graphics';
import { Matrix3D as AwayMatrix3D } from '@awayjs/core';
/*
  * _matrix stores data by columns
  *  | 0  4  8  12 |
  *  | 1  5  9  13 |
  *  | 2  6 10  14 |
  *  | 3  7 11  15 |
  */
var transposeTransform = new Uint32Array([
    0, 4, 8, 12, 1, 5, 9, 13, 2, 6, 10, 14, 3, 7, 11, 15
]);
var Matrix3D = /** @class */ (function (_super) {
    __extends(Matrix3D, _super);
    function Matrix3D(v) {
        if (v === void 0) { v = null; }
        var _this = _super.call(this) || this;
        if (v instanceof AwayMatrix3D) {
            _this._adaptee = v;
        }
        else {
            _this._adaptee = new AwayMatrix3D();
            if (v && v.length >= 16) {
                _this.copyRawDataFrom(v, 0, false);
            }
            else {
                _this.identity();
            }
        }
        return _this;
    }
    Object.defineProperty(Matrix3D.prototype, "adaptee", {
        get: function () {
            return this._adaptee;
        },
        enumerable: true,
        configurable: true
    });
    Matrix3D.interpolate = function (thisMat, toMat, percent) {
        percent = +percent;
        release || notImplemented('public flash.geom.Matrix3D::static interpolate');
        return;
    };
    Object.defineProperty(Matrix3D.prototype, "rawData", {
        get: function () {
            var result = new this.sec.Float64Vector();
            this.copyRawDataTo(result, 0, false);
            return result;
        },
        set: function (v) {
            this.copyRawDataFrom(v, 0, false);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Matrix3D.prototype, "position", {
        get: function () {
            return new this.sec.flash.geom.Vector3D(this._adaptee.position);
        },
        set: function (pos) {
            this.copyColumnFrom(3, pos);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Matrix3D.prototype, "determinant", {
        get: function () {
            return this._adaptee.determinant;
        },
        enumerable: true,
        configurable: true
    });
    Matrix3D.prototype.clone = function () {
        return new this.sec.flash.geom.Matrix3D(this._adaptee.clone());
    };
    Matrix3D.prototype.copyToMatrix3D = function (dest) {
        this._adaptee.copyTo(dest.adaptee);
    };
    Matrix3D.prototype.append = function (lhs) {
        this._adaptee.append(lhs.adaptee);
    };
    Matrix3D.prototype.prepend = function (rhs) {
        this._adaptee.prepend(rhs.adaptee);
    };
    Matrix3D.prototype.invert = function () {
        return this._adaptee.invert();
    };
    Matrix3D.prototype.identity = function () {
        this._adaptee.identity();
    };
    Matrix3D.prototype.decompose = function (orientationStyle) {
        if (orientationStyle === void 0) { orientationStyle = 'eulerAngles'; }
        this._adaptee.decompose(orientationStyle);
        orientationStyle = axCoerceString(orientationStyle);
        release || notImplemented('public flash.geom.Matrix3D::decompose');
        return;
    };
    Matrix3D.prototype.recompose = function (components, orientationStyle) {
        if (orientationStyle === void 0) { orientationStyle = 'eulerAngles'; }
        //this._adaptee.recompose()
        orientationStyle = axCoerceString(orientationStyle);
        release || notImplemented('public flash.geom.Matrix3D::recompose');
        return;
    };
    Matrix3D.prototype.appendTranslation = function (x, y, z) {
        this._adaptee.appendTranslation(+x, +y, +z);
    };
    Matrix3D.prototype.appendRotation = function (degrees, axis, pivotPoint) {
        if (pivotPoint === void 0) { pivotPoint = null; }
        release || somewhatImplemented('public flash.geom.Matrix3D::appendRotation');
        this._adaptee.appendRotation(+degrees, axis.adaptee);
    };
    Matrix3D.prototype.appendScale = function (xScale, yScale, zScale) {
        this._adaptee.appendScale(+xScale, +yScale, +zScale);
    };
    Matrix3D.prototype.prependTranslation = function (x, y, z) {
        this._adaptee.prependTranslation(+x, +y, +z);
    };
    Matrix3D.prototype.prependRotation = function (degrees, axis, pivotPoint) {
        if (pivotPoint === void 0) { pivotPoint = null; }
        release || somewhatImplemented('public flash.geom.Matrix3D::prependRotation');
        this._adaptee.prependRotation(+degrees, axis.adaptee);
    };
    Matrix3D.prototype.prependScale = function (xScale, yScale, zScale) {
        this._adaptee.prependScale(+xScale, +yScale, +zScale);
    };
    Matrix3D.prototype.transformVector = function (v) {
        return new this.sec.flash.geom.Vector3D(this._adaptee.transformVector(v.adaptee));
    };
    Matrix3D.prototype.deltaTransformVector = function (v) {
        return new this.sec.flash.geom.Vector3D(this._adaptee.deltaTransformVector(v.adaptee));
    };
    Matrix3D.prototype.transformVectors = function (vin, vout) {
        var m = this._adaptee._rawData;
        var m11 = m[0], m12 = m[4], m13 = m[8], m14 = m[12], m21 = m[1], m22 = m[5], m23 = m[9], m24 = m[13], m31 = m[2], m32 = m[6], m33 = m[10], m34 = m[14];
        for (var i = 0; i < vin.length - 2; i += 3) {
            var x = vin.axGetNumericProperty(i), y = vin.axGetNumericProperty(i + 1), z = vin.axGetNumericProperty(i + 2);
            vout.push(m11 * x + m12 * y + m13 * z + m14);
            vout.push(m21 * x + m22 * y + m23 * z + m24);
            vout.push(m31 * x + m32 * y + m33 * z + m34);
        }
    };
    Matrix3D.prototype.transpose = function () {
        this._adaptee.transpose();
    };
    Matrix3D.prototype.pointAt = function (pos, at, up) {
        if (at === void 0) { at = null; }
        if (up === void 0) { up = null; }
        release || notImplemented('public flash.geom.Matrix3D::pointAt');
        return;
    };
    Matrix3D.prototype.interpolateTo = function (toMat, percent) {
        percent = +percent;
        release || notImplemented('public flash.geom.Matrix3D::interpolateTo');
        return;
    };
    Matrix3D.prototype.copyFrom = function (sourceMatrix3D) {
        this._adaptee.copyFrom(sourceMatrix3D.adaptee);
    };
    Matrix3D.prototype.copyRawDataTo = function (vector, index, transpose) {
        if (index === void 0) { index = 0; }
        if (transpose === void 0) { transpose = false; }
        index = index >>> 0;
        transpose = !!transpose;
        var m = this._adaptee._rawData;
        if (transpose) {
            for (var i = 0, j = index | 0; i < 16; i++, j++) {
                vector.axSetNumericProperty(j, m[transposeTransform[i]]);
            }
        }
        else {
            for (var i = 0, j = index | 0; i < 16; i++, j++) {
                vector.axSetNumericProperty(j, m[i]);
            }
        }
    };
    Matrix3D.prototype.copyRawDataFrom = function (vector, index, transpose) {
        if (index === void 0) { index = 0; }
        if (transpose === void 0) { transpose = false; }
        index = index >>> 0;
        transpose = !!transpose;
        var m = this._adaptee._rawData;
        if (transpose) {
            for (var i = 0, j = index | 0; i < 16; i++, j++) {
                m[transposeTransform[i]] = vector.axGetNumericProperty(j) || 0; // removing NaN
            }
        }
        else {
            for (var i = 0, j = index | 0; i < 16; i++, j++) {
                m[i] = vector.axGetNumericProperty(j) || 0; // removing NaN
            }
        }
    };
    Matrix3D.prototype.copyRowTo = function (row /*uint*/, vector3D) {
        this._adaptee.copyRowTo(row >>> 0, vector3D.adaptee);
    };
    Matrix3D.prototype.copyColumnTo = function (column /*uint*/, vector3D) {
        this._adaptee.copyColumnTo(column >>> 0, vector3D.adaptee);
    };
    Matrix3D.prototype.copyRowFrom = function (row /*uint*/, vector3D) {
        this._adaptee.copyRowFrom(row >>> 0, vector3D.adaptee);
    };
    Matrix3D.prototype.copyColumnFrom = function (column /*uint*/, vector3D) {
        this._adaptee.copyColumnFrom(column >>> 0, vector3D.adaptee);
    };
    Matrix3D.classInitializer = null;
    return Matrix3D;
}(ASObject));
export { Matrix3D };
